import React, {useState} from 'react';
// the hook
import {useTranslation} from 'react-i18next';
import {Divider,Button} from 'antd';
import {history,addVisitLog} from "../../libs";


import style from './index.module.less'
import advantage1 from './advantage1.png';
import advantage2 from './advantage2.png';
import advantage3 from './advantage3.png';
import productBg from './product-bg.png';
import productBg2 from './product-bg2.png';
import productBg3 from './product-bg3.png';
import banner_title from './banner_title.png';
import introduction1 from './introduction-01.png';
import introduction2 from './introduction-02.png';
import introduction3 from './introduction-03.png';
import introduction4 from './introduction-04.png';
import introduction5 from './introduction-05.png';
import serviceArea from './serviceArea.png';
import emailImg from './email.png';
import phoneImg from './phone.png';
import addressImg from './address.png';
import titleLeft from './title-left.png';
import titleRight from './title-right.png';


export default function () {
  const {t, i18n} = useTranslation();// {t('')}
  const [advantageActive, setAdvantageActive] = useState(0);//服务优势选中
  const [allRangeActive, setAllRangeActive] = useState(1);//全方位服务选中
  const [introductionActive, setIntroductionActive] = useState(0);//服务范围选中

  const startSelection = ()=>{
    addVisitLog({
      pageName: '开始选品',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: 'ClickStartSelect',
      eventName: "开始选品",
    })
    history.push('./goods');
  }
  const introductionList = [
    {
      title:'临床设备采购/租赁',
      des:'提供为期最长5年的设备租赁、流转、维护务；用户成本、支出的合理建议方案。',
      bgImg:introduction1
    },
    {
      title:'平台化设备管理',
      des:'数字化平台实现设备资产全生命周期管理，完整日志追踪设备轨迹；高专业度的服务能力实现设备共享。资源利用最大化。',
      bgImg:introduction2
    },
    {
      title:'临床设备回收及仓储',
      des:'提供设备报废残体处理，项目结束回收仓储、维护、二次投放服务。',
      bgImg:introduction3
    },
    {
      title:'临床耗材供应',
      des:'临床相关耗材一站式供应；提供智能、便捷、全面的解决方案。',
      bgImg:introduction4
    },
    {
      title:'定期计量',
      des:'每年提供中国计量院/资质第三方出具的计量服务。',
      bgImg:introduction5
    }
  ]
  return (
    <div className={style.picBox}>
      {
        // i18n.language === 'zh' ? (
          <>
           <div className={style.home_banner2}>
              <div className='banner2_content'>
                <div className='banner2_title_desc'>零设备资产启动临床试验</div>
                <div className='banner2_title'><img src={banner_title} alt="" /></div>
                <div className='banner2_desc'>
                  除搜索查询产品，完成询价和下单（租赁或采买）功能外，平台可在线实现设备管理，如：提供用户所需设备信息、设备流转记录、计量证书下载、租期和校准证书效期提醒等功能。
                </div>
                <div className='banner2_btn'>
                  <Button className='bannerBtn' type="primary" shape="round" onClick={()=>startSelection()}>开始选品</Button>
                </div>
              </div>
            </div>
           <div className={style.home_advantage}>
              <div className='home_advantage_title'>
                <img src={titleLeft} alt="" />
                  <h3>全方位服务</h3>
                <img src={titleRight} alt="" />
              </div>
              <div className='home_advantage_content'>
                <div className='advantage_item'>
                <div className='advantage_item_img'>
                    <img src={productBg} alt="" />
                  </div>
                  <div className='advantage_item_title'>| <span>租</span> |</div>
                  <div className='advantage_desc2'>租赁服务，让申办方0设备资产快速启动临床试验。</div>
                  <div className='advantage_desc3'>租赁范围：<span className='blod'>冰箱、离心机、恒温箱、输液泵、温湿度记录仪、心电图机</span>等临床试验常用设备。</div>
                </div>
                <div className='advantage_item'>
                <div className='advantage_item_img'>
                    <img src={productBg2} alt="" />
                  </div>
                  <div className='advantage_item_title'>| <span>售</span> |</div>
                  <div className='advantage_desc2'>一站式供给服务，满足申办方个性化的采买需求。</div>
                  <div className='advantage_desc3'>服务范围：<span className='blod'>通用设备、耗材、低值易耗品。</span></div>
                </div>
                <div className='advantage_item'>
                <div className='advantage_item_img'>
                    <img src={productBg3} alt="" />
                  </div>
                  <div className='advantage_item_title'>| <span>管</span> |</div>
                  <div className='advantage_desc2'>设备管理服务，助力申办方的资管合规、规避风险、降本增效。</div>
                  <div className='advantage_desc3'>服务范围：<span className='blod'>设备全国校准、设备转运、设备仓储和销毁服务。</span></div>
                </div>
              </div>
            </div>
            <div className={style.allRangeService}>
              <div className={['allRangeService_item','allRangeService_bg1',allRangeActive === 0 ? 'allRangeService_hover_bg' : ''].join(' ')}
                onMouseEnter={()=>setAllRangeActive(0)}>
                <div className='allRangeService_item_title'>全程数字化</div>
                <div className='allRangeService_item_desc'>所有采买和租赁的设备信息可实时查看、下载和追溯。项目间设备的流转信息和服务信息全程无断点。</div>
              </div>
              <div className={['allRangeService_item','allRangeService_bg2',allRangeActive === 1 ? 'allRangeService_hover_bg' : ''].join(' ')}
                onMouseEnter={()=>setAllRangeActive(1)}>
                <div className='allRangeService_item_title'>风控/预警</div>
                <div className='allRangeService_item_desc'>系统根据申办方需求自动发送设备校准到期提醒、租赁到期提醒，规避过期风险。</div>
              </div>
              <div className={['allRangeService_item','allRangeService_bg3',allRangeActive === 2 ? 'allRangeService_hover_bg' : ''].join(' ')}
                onMouseEnter={()=>setAllRangeActive(2)}>
                <div className='allRangeService_item_title'>极速响应</div>
                <div className='allRangeService_item_desc'>
                  <p>所咨询/报价：专属客服“1H“报价，协助选型、技术咨询！</p>
                  <p>发货：优选设备充足备货，完善的紧急替换方案！</p>
                  <p>售后：1小时响应，8小时提供解决方案！</p>
                </div>
              </div>
              <div className={['allRangeService_item','allRangeService_bg4',allRangeActive === 3 ? 'allRangeService_hover_bg' : ''].join(' ')}
                onMouseEnter={()=>setAllRangeActive(3)}>
                <div className='allRangeService_item_title'>降本增效</div>
                <div className='allRangeService_item_desc'>
                  <p>租赁服务：共享经济模式，使申办方成本更低、浪费最小、最环保！</p>
                  <p>多业务模块组合：个性化服务，根据申办方具体情况，提供定制服务方案，最大限度使用资源！</p>
                </div>
              </div>
            </div>
              <div className={style.zeroContainer}>
                  <div className='zero_title'>
                    <img src={titleLeft} alt="" />
                    <h3>服务范围</h3>
                    <img src={titleRight} alt="" />
                  </div>
                  <div className='content'>
                    <div className='left'>
                      <div className='left_title'>
                        <p>
                          可供租赁的临床试验常用设备采取<span className='bold'>长期</span>备货！
                        </p>
                       <p>
                        在主要医药园区有<span className='bold'>现货</span>仓储！
                       </p>
                        <p>
                          可<span className='bold'>快速</span>调拨现货至临床医药研发集群！
                        </p>
                      </div>
                      <div className='left_desc'> 
                        <div className='desc_item'>
                          <div>北京</div>
                          <span>华北仓</span>
                        </div>
                        <div className='desc_item'>
                          <div>成都</div>
                          <span>华西仓</span>
                        </div>
                        <div className='desc_item'>
                          <div>广州</div>
                          <span>华南仓</span>
                        </div>
                        <div className='desc_item'>
                          <div>上海</div>
                          <span>华东仓</span>
                        </div>
                      </div>
                    </div>
                    <div className='right'>
                      <img src={serviceArea} alt="" />
                    </div>
                  </div>
              </div> 
              <div className={style.business_item}>
                  {/* <div className='business_title'>
                    <h3>业务介绍</h3>
                  </div> */}
                  <div className='business_content'>
                    {
                      introductionList.map((item,index)=>
                        <div className={['introduction_item',introductionActive === index ? 'introduction_hover_bg' : ''].join(' ')}
                          onMouseEnter={()=>setIntroductionActive(index)}>
                          <div className='introduction_text'>
                            <div className='introduction_title'>{item.title}</div>
                            <div className='split_line'></div>
                            <div className='introduction_subTitle'>{item.des}</div>
                          </div>
                          <img src={item.bgImg} className='introduction_bg'/>
                        </div>
                    )}
                  </div>
              </div>
              <div className={style.business_advantage}>
                  <div className='business_title'> 
                    <div>服务优势</div>
                  </div>
                  <div className='business_content'>
                    <div className={['advantage_item',advantageActive === 0 ? 'advantage_hover_bg' : ''].join(' ')}
                      onMouseEnter={()=>setAdvantageActive(0)}>
                      <div className='advantage_desc1'>
                        <img src={advantage1} alt="" />
                      </div>
                      <div className='advantage_desc2'>设备需求前置，提前备货，做到<span className='blod'>急货急发</span>。</div>
                      <div className='advantage_desc3'>针对客户确定的需求可以先备库做好计量，等客户通知发货，节省临床研发时间。</div>
                    </div>
                    <div className={['advantage_item',advantageActive === 1 ? 'advantage_hover_bg' : ''].join(' ')}
                      onMouseEnter={()=>setAdvantageActive(1)}>
                      <div className='advantage_desc1'>
                        <img src={advantage2} alt="" />
                      </div>
                      <div className='advantage_desc2'>租赁期间免费<span className='blod'>暂存及代发</span>服务，共享仓库及库管服务。</div>
                      <div className='advantage_desc3'>针对客户确定的需求可以先备库做好计量，等客户通知发货，节省临床研发时间。</div>
                    </div>
                    <div className={['advantage_item',advantageActive === 2 ? 'advantage_hover_bg' : ''].join(' ')}
                      onMouseEnter={()=>setAdvantageActive(2)}>
                      <div className='advantage_desc1'>
                        <img src={advantage3} alt="" />
                      </div>
                      <div className='advantage_desc2'>全国范围<span className='blod'>上门服务</span>，让计量、<span className='blod'>售后无忧</span>。</div>
                      <div className='advantage_desc3'>全国主要城市的定点医院的设备计量、售后维修、防护运输、拆箱安装等服务要求，积极响应。</div>
                    </div>
                  </div>
              </div>
              <div className={style.contact_us_container}>
                <div className='contact_us_title'>
                  <div>联系我们</div>
                </div>
                <div className='contact_content'>
                  <div className='contact_item'>
                    <img src={emailImg} alt="" />
                    <div className='contact_item_title'>
                      邮箱
                    </div>
                    <div className='contact_item_desc'>
                      cssc@lab-direct.com
                    </div>
                  </div>
                  <Divider className='divider' type="vertical" />
                  <div className='contact_item'>
                    <img src={phoneImg} alt="" />
                    <div className='contact_item_title'>
                      服务热线
                    </div>
                    <div className='contact_item_desc'>
                      400-086-5292
                    </div>
                  </div>
                  <Divider className='divider' type="vertical" />
                  <div className='contact_item'>
                    <img src={addressImg} alt="" />
                    <div className='contact_item_title'>
                      地址
                    </div>
                    <div className='contact_item_desc'>
                      上海市浦东新区盛荣路388弄百佳通1号楼
                    </div>
                  </div>
                </div>
              </div> 
          </>
      }

    </div>
  )
}
